import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/components/LogIn.vue';
import Notfound from '@/components/NotFound.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'LogIn', component: Login},
  {
    path: '/:pathMatch(.*)',
    name: 'notfound',
    component: Notfound
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
